import React, { useState } from 'react'
import Style from './SearchBar.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
const SearchBar = (props) => {
    const[SerachBTN,setSearchBTN]=useState(false)

    const SearchValueHandler=(e)=>{
        if(e!==null){
            setSearchBTN(true)
        }
        if(e===''){
            setSearchBTN(false)
        }
        props.setSearch(e)
    }
    return (
        <div className={Style.SerachHolder}>
            <div className={SerachBTN?Style.inputHolder:Style.fullInputHolder}>
                <input type={'text'} placeholder={"جست و جو..."} onChange={(e)=>SearchValueHandler(e.target.value)} />
            </div>
            <button className={SerachBTN?Style.SearchButton:Style.SearchButtonHide}><FontAwesomeIcon icon={faSearch}/></button>
        </div>
    )
}
export default SearchBar
